import { render, staticRenderFns } from "./FanReplacementStatus.vue?vue&type=template&id=2aa48dc0&"
import script from "./FanReplacementStatus.vue?vue&type=script&lang=js&"
export * from "./FanReplacementStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports